import { useMemo } from 'react';

import { useGET } from '../shared/hooks';
import QueryString from '../../lib/QueryString';

const toUrl = query => `/teams${query}`;

export function usePaginatedTeams(
  league,
  season,
  name,
  currentPage = 0,
  pageSize = 30,
) {
  let url = '';
  const query = getQuery(league, season, name, currentPage, pageSize);
  url = toUrl(query);
  const data = useGET(url);
  return useMemo(() => responseToPaginatedTeams(data), [data]);
}

function responseToPaginatedTeams(data) {
  if (!data) return {};
  return {
    teams: data.results,
    teamsCount: data.count,
  };
}

const getQuery = (league, season, name, currentPage, pageSize) => {
  const query = new QueryString();
  query.addValue('limit', pageSize);
  query.addValue('offset', currentPage * pageSize);
  if (league) query.addValue('league_id', league.id);
  if (season) query.addValue('season_id', season.id);
  if (name) query.addValue('name', encodeURIComponent(name));
  query.addValue('ordering', '-preferred,name');
  return query.toString();
};
